import { useWatch } from "react-hook-form";

import { getTextColor } from "helpers/tags";

const TagColorPreview = () => {
  const [name, color, enabled] = useWatch({
    name: ["name", "color", "enabled"],
  });
  const background = enabled ? color : "#ffffff";

  return (
    <span
      className="tw:inline-flex tw:h-8 tw:max-w-48 tw:items-center tw:rounded-md tw:border tw:border-[var(--color-border)] tw:px-3 tw:text-sm"
      style={{
        backgroundColor: background,
        color: getTextColor(background),
        fontStyle: enabled ? "normal" : "italic",
      }}
    >
      <span className="tw:min-w-0 tw:truncate">{name || "Sample"}</span>
    </span>
  );
};

export default TagColorPreview;
